module.exports = __webpack_public_path__ + "img/ic-heart-pink.bfa98074.svg";